import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-text" }
const _hoisted_2 = ["disabled", "rows", "placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SendButton = _resolveComponent("SendButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      ref: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      disabled: $props.generating,
      class: "input",
      rows: $data.rows,
      placeholder: $props.placeholder,
      maxlength: "2048",
      onFocusin: _cache[1] || (_cache[1] = $event => (_ctx.$emit('focusin', $event))),
      onFocusout: _cache[2] || (_cache[2] = $event => (_ctx.$emit('focusout', $event))),
      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers((...args) => ($options.onKeyEnter && $options.onKeyEnter(...args)), ["stop"]), ["enter"]))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
      [_vModelText, _ctx.value]
    ]),
    (!$props.controls)
      ? (_openBlock(), _createBlock(_component_SendButton, {
          key: 0,
          class: "send",
          generating: $props.generating,
          "can-push": $props.canPush,
          onPush: _cache[4] || (_cache[4] = $event => (_ctx.$emit('push', $event))),
          onStop: _cache[5] || (_cache[5] = $event => (_ctx.$emit('stop')))
        }, null, 8 /* PROPS */, ["generating", "can-push"]))
      : _createCommentVNode("v-if", true)
  ]))
}